import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { translate } from 'parking-react-common'
import { ui, forms, auth, routing } from '../redux'

import Panel from '../components/Panel'
import PhoneLoginForm from '../components/PhoneLoginForm'
import PhoneVerificationForm from '../components/PhoneVerificationForm'
import SplashFooter from '../components/SplashFooter'

const PhoneLoginContainer = ({ isLoading, pendingVerificationPhone, t }) => (
    <div>
        <Panel
            title={
                pendingVerificationPhone
                    ? t('Please enter the code we sent you via SMS message.')
                    : t('To get started, please enter your phone number')
            }
            border={ ui.INTENT.primary }
            isLoading={ isLoading }
        >
            {
                pendingVerificationPhone
                    ? <PhoneVerificationForm initialValues={ { phone: pendingVerificationPhone } } />
                    : <PhoneLoginForm />
            }
        </Panel>
        {
            !pendingVerificationPhone && (
                <SplashFooter>
                    <span>{ t('Have a password set?') }</span>
                    <Link to={ routing.routeFor('phoneLoginWithPassword') }>
                        { t('Log in with password') }
                    </Link>
                </SplashFooter>
            )
        }
    </div>
)

PhoneLoginContainer.propTypes = {
    isLoading                : PropTypes.bool.isRequired,
    pendingVerificationPhone : PropTypes.string
}

function mapStateToProps(state) {
    return {
        isLoading                : forms.isSubmitting(forms.phoneLogin.id)(state),
        pendingVerificationPhone : auth.getPendingVerificationPhone(state)
    }
}

export default translate()(connect(mapStateToProps)(PhoneLoginContainer))
